const trimSpacesAndTrailingSlash = (path = '') => {
  const trimmedPath = path.trim();

  // If the path is not homepage ("/") and ends with a slash, remove that slash
  const pathWithoutTrailingSlash =
    trimmedPath !== '/' && trimmedPath.endsWith('/') ? path.slice(0, -1) : path;

  return pathWithoutTrailingSlash;
};

export default trimSpacesAndTrailingSlash;
